import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmPracticeDialog from 'components/modals/ConfirmPracticeDialog';
import { useDispatch } from 'react-redux';
import {
  actionSetPracticeTour,
  actionReset,
  actionSetSigningTimestamp
} from 'stores/signing';
import draftEntryHelper from 'helpers/draft-entry-helper';
import { refreshSavedLocation } from 'stores/app';
import { refreshDocumentList, refreshDocumentCollections } from 'stores/docs';

const PracticeModule = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);

  const handleModalClose = () => {
    navigate('/');
    setShowModal(false);
  };

  const handleModalStart = async () => {
    // const dummyDraftId = `dummy_draft_${Date.now()}`;
    // navigate(`/notary/signing`); //${dummyDraftId}
    // Clear the signing state before starting practice module
    dispatch(actionReset());
    dispatch(actionSetSigningTimestamp(null));
    // Dispatch action to set practiceTour state to true
    dispatch(actionSetPracticeTour({ practiceTour: true }));
    Promise.all([
      dispatch(refreshSavedLocation()),
      dispatch(refreshDocumentList()),
      dispatch(refreshDocumentCollections())
    ]);
    setShowModal(false);
    const draft_id = await draftEntryHelper.getNewDraftId();
    navigate(
      '/notary/signing/' +
        draftEntryHelper.getDarftKeyFromId(draft_id) +
        '?isPractice=1'
    );
  };

  return (
    <div>
      {/* Modal */}
      {showModal && (
        <ConfirmPracticeDialog
          show={showModal}
          title="Practice Journal Entry"
          body="Want to get some hands-on practice? This practice module will prepare you to use your Notary eJournal in the field by giving you access to all of the features of our app in a test environment. No entries are saved, and you can come back any time for more practice!"
          onStart={handleModalStart}
          onCancel={handleModalClose}
        />
      )}
    </div>
  );
};

export default PracticeModule;
